import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidate all workplace request type (and type-status) queries.
 * Use after creating, updating, deleting, or reordering request types / sub-statuses.
 */
export const useInvalidateWorkplaceRequestTypes = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["workplaceRequestTypes"]
    });
    await queryClient.invalidateQueries({
      queryKey: ["workplaceRequestTypeStatuses"]
    });
  }, [queryClient]);
};
